var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRef, useCallback, useEffect, useRef, useState, } from 'react';
import { classNames, renderIcon } from '../../utils';
import Button from '../button/button';
import Typography from '../typography/typography';
export var Steps = function (_a) {
    var items = _a.items, typeColor = _a.typeColor;
    var _b = useState(), refs = _b[0], setRefs = _b[1];
    var _c = useState([]), isAccordingOpen = _c[0], setIsAccordingOpen = _c[1];
    var divRefs = useRef([]);
    divRefs.current = Array.from({ length: items.length }, function () { return createRef(); });
    var typeStyle = useCallback(function (_a) {
        var icon = _a.icon, typeColor = _a.typeColor, itemColor = _a.itemColor;
        return ({
            todo: {
                style: "bg-".concat(itemColor || (typeColor === null || typeColor === void 0 ? void 0 : typeColor.todo) || 'tertiaryAccent2', " border-2 border-primary"),
                icon: (icon === null || icon === void 0 ? void 0 : icon.todo) || '',
                border: 'border-solid',
            },
            inProgress: {
                style: "bg-".concat(itemColor || 'primary'),
                icon: (icon === null || icon === void 0 ? void 0 : icon.inProgress) || 'CalendarIcon',
                border: 'border-dashed',
            },
            completed: {
                style: "bg-".concat(itemColor || (typeColor === null || typeColor === void 0 ? void 0 : typeColor.completed) || 'secondary'),
                icon: (icon === null || icon === void 0 ? void 0 : icon.completed) || 'CheckIcon',
                border: 'border-solid',
            },
        });
    }, []);
    var getStatus = useCallback(function (type, icon, itemColor) {
        switch (type) {
            case 'todo':
                return typeStyle({ typeColor: typeColor, icon: { todo: icon === null || icon === void 0 ? void 0 : icon.todo }, itemColor: itemColor })
                    .todo;
            case 'inProgress':
                return typeStyle({
                    icon: { inProgress: icon === null || icon === void 0 ? void 0 : icon.inProgress },
                    itemColor: itemColor,
                }).inProgress;
            default:
                return typeStyle({
                    typeColor: typeColor,
                    icon: { completed: icon === null || icon === void 0 ? void 0 : icon.completed },
                    itemColor: itemColor,
                }).completed;
        }
    }, [typeStyle, typeColor]);
    var handleOnClickAccording = useCallback(function (index) {
        setIsAccordingOpen(function (prevState) {
            if (prevState.some(function (item) { return item.index === index; })) {
                return prevState === null || prevState === void 0 ? void 0 : prevState.map(function (item) {
                    if (item.index === index) {
                        return __assign(__assign({}, item), { isOpen: !item.isOpen });
                    }
                    return item;
                });
            }
            return __spreadArray(__spreadArray([], prevState, true), [{ index: index, isOpen: true }], false);
        });
    }, []);
    useEffect(function () {
        setTimeout(function () {
            setRefs(divRefs === null || divRefs === void 0 ? void 0 : divRefs.current);
        }, 100);
    }, [items, isAccordingOpen]);
    return (_jsx("div", { children: items &&
            items.map(function (item, index) {
                var _a, _b, _c, _d, _e, _f, _g;
                var isOpen = (_a = isAccordingOpen === null || isAccordingOpen === void 0 ? void 0 : isAccordingOpen.find(function (item) { return item.index === index; })) === null || _a === void 0 ? void 0 : _a.isOpen;
                return (_jsxs("div", __assign({ id: String(index), ref: divRefs === null || divRefs === void 0 ? void 0 : divRefs.current[index], className: "relative flex gap-5 pb-6" }, { children: [items.length !== index + 1 && (_jsx("div", { className: classNames('absolute top-0 z-0 border-2', (_b = getStatus(item.type)) === null || _b === void 0 ? void 0 : _b.border), style: {
                                borderColor: (!items[index - 1] ||
                                    (items[index - 1] &&
                                        items[index - 1].type === 'completed')) &&
                                    item.type === 'completed' &&
                                    items[index + 1] &&
                                    items[index + 1].type === 'completed'
                                    ? "var(--".concat(item.color || (typeColor === null || typeColor === void 0 ? void 0 : typeColor.completed) || 'secondary', ")")
                                    : "var(--".concat(item.color ||
                                        (typeColor === null || typeColor === void 0 ? void 0 : typeColor.todoAndInProgress) ||
                                        'primary', ")"),
                                height: refs && ((_d = (_c = refs[index]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.clientHeight),
                                left: 14,
                            } })), _jsx("div", __assign({ className: "z-10" }, { children: _jsx("div", __assign({ className: classNames('min-h-8 min-w-8 flex h-8 w-8 items-center justify-center rounded-full', (_e = getStatus(item.type, {}, item === null || item === void 0 ? void 0 : item.color)) === null || _e === void 0 ? void 0 : _e.style) }, { children: ((_f = getStatus(item.type)) === null || _f === void 0 ? void 0 : _f.icon) &&
                                    renderIcon((_g = getStatus(item.type, {
                                        completed: item.completedStepIcon,
                                        inProgress: item.inProgressStepIcon,
                                        todo: item === null || item === void 0 ? void 0 : item.todoStepIcon,
                                    })) === null || _g === void 0 ? void 0 : _g.icon, 'text-white w-5 h-5') })) })), _jsxs("div", __assign({ style: { width: isOpen ? '75%' : '87%' }, className: "" }, { children: [_jsx(Typography, { type: "body", align: "left", weight: "bold", text: item.title, color: "textDark", className: "col-span-2 break-words" }), item.subTitle && (_jsx(Typography, { className: "col-span-2 row-span-2", type: "body", align: "left", weight: "skinny", text: item.subTitle, color: item.subTitleColor || 'textMid' })), item.customSubTitle, item.showAccordion && isOpen && item.accordionContent] })), item.showActionButton && (_jsx("div", __assign({ className: "absolute right-0 flex w-32 justify-end" }, { children: _jsx(Button, __assign({ type: (item === null || item === void 0 ? void 0 : item.actionButtonType) || 'filled', color: item.actionButtonColor || 'primary' }, (item.actionButtonIcon && {
                                icon: item.actionButtonIcon,
                            }), { iconPosition: (item === null || item === void 0 ? void 0 : item.actionButtonIconStartPosition) ? 'start' : 'end', isLoading: item.actionButtonIsLoading, disabled: item.actionButtonIsLoading, className: 'h-9 w-auto', onClick: item.actionButtonOnClick, text: item.actionButtonText, textColor: item.actionButtonTextColor || 'white' })) }))), item.showAccordion && (_jsx("button", __assign({ className: "absolute right-4 top-2 z-0 flex h-full w-full justify-end", onClick: function () { return handleOnClickAccording(index); } }, { children: renderIcon(isOpen ? 'ChevronUpIcon' : 'ChevronDownIcon', 'w-8 h-8 text-primary') })))] }), "step-".concat(item.title, "-").concat(index)));
            }) }));
};
//# sourceMappingURL=index.js.map